const modalEvents: {
  events: { [key: string]: () => void };
  templates: { [key: string]: React.ReactNode };
} = {
  events: {},
  templates: {},
};

export default modalEvents;
